module.exports = __webpack_public_path__ + "static/media/left-arrow.a86bf6c8.svg";